// ng build --prod --aot=false --build-optimizer=false
// firebase deploy --only hosting:merchant-board-dev
// firebase deploy --only hosting:merchant-board-uat    
// firebase deploy --only hosting:merchant-board-phl-uat
// firebase deploy --only hosting:merchant-board-live
// firebase deploy --only hosting:merchant-board-phl


// firebase deploy --only hosting:merchant-board-ca-uat


import { InstanceName } from "src/app/utilities/common-file";

// npm run generate:svg-sprite
// https://merchant-board-uat.firebaseapp.com/


export const Config = {
    // DEV  
    // hst:'true',
    // appCode : InstanceName.dev,
    // baseUrl: 'https://ffp3admin-api-dev.flexm.com',
    // merchantPaymentLink:'https://dev-merchant-payment-flexm.web.app/pay/',
    // apiKey : 'JPKVD25-3AM4S44-QGBVGJZ-3J8NHTS',//ADB key    
    // clientPrivateKey: '1ea9e25f61d59d0d4cd56daa3a53a2bd034f6e0eb79c2e3a214d7fef841c7a21',
    // clientPublicKey: '04184619b5245772c8d0126b5f9ee1331a4ad6b8f700b112ef2c3cb3968352cc6f2c4ecb4b4c222c451c6020882f435248300e11101dcc315960cbb45dc1a2d6bc',
    // serverPublicKey: '048f26963af57cc3b22daccec961c844badb78d6bcaa47aeeca9c6dab4cfcf404e54e24b4c25ab02ef5e593ace7b1ee684eaa064c504add1eaf10c0403d7329fed',
    // //  apiKey : '7JD14W2-WVZ4DPS-GD76K7W-67AY2XF',//connect key
    // DatabaseConfig: {
    //     apiKey: "AIzaSyBYkyK_njEWi0maN4Y9JhnJPlD6W7zVKPc",
    //     authDomain: "admin-board-1a026.firebaseapp.com",
    //     databaseURL: "https://admin-board-1a026.firebaseio.com",
    //     projectId: "admin-board-1a026",
    //     storageBucket: "admin-board-1a026.appspot.com",
    //     messagingSenderId: "438952667608",
    //     appId: "1:438952667608:web:20575810556b6e66bdaaad",
    //     measurementId: "G-2BCDE0DB1V"
    // }

    // UATSG  
    // hst:'false',
    // appCode : InstanceName.uatSG,
    // baseUrl: 'https://ffp3admin-api-uat.flexm.com',
    // merchantPaymentLink:'https://dev-merchant-payment-flexm.web.app',
    // apiKey : 'GN03641-K7R4H1C-NKCET7K-CWY7TYN',
    // clientPrivateKey: '3987a78712e61ad3e90c8d9de58997364c873b094ee149f88c5cc4fe99edb10a',
    // clientPublicKey: '04ed8bbc96e524e3caa27789a043983059f47ce4f9857b52e98081430255fa9609c67567c20fac72f6d0f609849391a28f3d45e3c072c5d2b30642bc11ba0f3322',
    // serverPublicKey: '04fa74c67c8abe10c33930608a4fe0df3c0696f069ab7b935bf2b788a00e9350f03b8f23501f6605c7b474230ddac98259332154ac1205c86e8384cb5dbc338d83',
    // DatabaseConfig: {
    //     apiKey: "AIzaSyArsKTsHIoc5kNCsTCU2fPr7GW7BKtVJQs",
    //     authDomain: "admin-board-uat.firebaseapp.com",
    //     databaseURL: "https://admin-board-uat.firebaseio.com",
    //     projectId: "admin-board-uat",
    //     storageBucket: "admin-board-uat.appspot.com",
    //     messagingSenderId: "125588095849",
    //     appId: "1:125588095849:web:ff54cbcad6635ae0f5f3f8",
    //     measurementId: "G-W3HRY6F3V9"
    // }

    // UATPHP  
    hst:'false',
    appCode : InstanceName.uatPHP,
    baseUrl: 'https://ffp3admin-api-ph-uat.flexm.com',
    merchantPaymentLink:'https://phl-uat-merchant-payment-flexm.web.app/pay/',
    apiKey : 'KWWZ85K-1J34F7S-NE5A8G6-WBF8PWW',
    clientPrivateKey: '41b06138fef51d05215ee3115c457df80c2d01228e0c930a66273f65749776d6',
    clientPublicKey: '04e2785a7aa8d2d4f98342c3e5fd50a4b385eb11132ecbdf4d80ed7061addddabcf57f3ddc8942cc9993149f32db94d386046385552f5a7a9feeb0f75dae2ccb77',
    serverPublicKey: '041634a80dd5d2d50fa6b8f35126e7083fcaa483b029c809f93f3dc9bfc4faee9cea67ae3da157b57dc4c89a3a53430f4e588c1965f62921afbf49bb2d1cc25349',
      DatabaseConfig: {
        apiKey: "AIzaSyBnta5p1vKLmgysKezRyUoKnQULjzGSji0",
        authDomain: "admin-board-phl-uat.firebaseapp.com",
        projectId: "admin-board-phl-uat",
        storageBucket: "admin-board-phl-uat.appspot.com",
        messagingSenderId: "436621403564",
        appId: "1:436621403564:web:176e00c7c3061fb5b1c609",
        measurementId: "G-Y9ZK0PV0ES"
    }

    // LIVESG  
    // hst:'false',
    // appCode : InstanceName.liveSG,
    // baseUrl: 'https://ffp3admin-api-sg.flexm.com',
    // merchantPaymentLink:'https://dev-merchant-payment-flexm.web.app',
    // apiKey : 'ZPFNCZJ-M3P4JW8-JDYDJFV-A6N95T6',             
    // clientPrivateKey: '3d6e338fb189643e3180c5a7406648ba2e35008ff1a8c4e7e1f08fdc183d7436',
    // clientPublicKey: '045c84aa02b6f2b95265fbf0942ff3f9d2e6be295b71584accbcf5dc3a416aa16aa36dd9921c2c6dd4088897b17ced7ffe7a1a901c2dca7a48352be19da3435def',
    // serverPublicKey: '0408a6c2ac7a55824ee723bee6a06940c4e3358d2c3d38aeff282e1d710e84ef25fb69ead8aec7d4b9d2489166721ea505b65879008c5f45e0dd1a4b34fd045ea1'
    // DatabaseConfig: {
    //     apiKey: "AIzaSyC9xu4652x7d7Vnkx_qPnMWBDA9VjzA7-Q",
    //     authDomain: "admin-board-v3.firebaseapp.com",
    //     projectId: "admin-board-v3",
    //     storageBucket: "admin-board-v3.appspot.com",
    //     messagingSenderId: "842748937961",
    //     appId: "1:842748937961:web:353c21dceebcdaad68d278",
    //     measurementId: "G-2K0V0PRDJJ"
    // }

    // LIVEPHP 
    // hst:'false',
    // appCode : InstanceName.livePHP,
    // baseUrl: 'https://ffp3admin-api-ph.flexm.com',
    // merchantPaymentLink:'https://dev-merchant-payment-flexm.web.app',
    // apiKey : '6W657YF-CY347XA-PZ75PB7-3SCG17M',          
    // clientPrivateKey: '7bc7566c69b400a60958f6591f8e29c09e10cc04ff18344895bc14c8f8165dd3',
    // clientPublicKey: '0480ff20e44c35d7db863cd0acbd9b612497bb0279c0b35765207afc49781d157db00be6f80a03986e4ae4e0562eaef692e26decc8602b97c62b16924164d13e66',
    // serverPublicKey: '041768febaa75f86227d0282adc1884fe76a78e28bbfbb601daa82602d720469f73d130d6a4a90993a189bd35db4020397055fd0b0eb4210f50a54416f4514b87f'
    // DatabaseConfig: {
    //     apiKey: "AIzaSyDIRhSqm1Fxl-REjp1IXJNM9JHTQ2FYYBM",
    //     authDomain: "admin-board3-ph-live-4953d.firebaseapp.com",
    //     projectId: "admin-board3-ph-live-4953d",
    //     storageBucket: "admin-board3-ph-live-4953d.appspot.com",
    //     messagingSenderId: "92660637910",
    //     appId: "1:92660637910:web:d7bb6eefcb84d435156977",
    //     measurementId: "G-WMMV6EJQK4"
    // }
};
